<script setup>
  const { event } = defineProps(['event']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <div class="heading">
    <EventLogo small :event="event" />
  </div>
  <h2>
    <span>{{ useTournamentSize(event.size) }}</span> {{ event.tournament_title }}
  </h2>
  <TickerTape v-if="event.tournament_fighter_names?.length" :items="event.tournament_fighter_names" class="ticker" />
  <ul v-if="event.tournament_fighter_names?.length">
    <li v-for="fighter in event.tournament_fighter_names">{{ fighter }}</li>
  </ul>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  .heading {
    margin: px(92) 0 px(28);

    display: flex;
    align-items: flex-end;

    gap: px(24);
  }

  h2 {
    @include title-xl;
  }

  .ticker {
    margin: px(12) 0 px(6);
  }

  ul {
    flex-direction: column;
    align-items: center;
    gap: px(5);

    @include title-xs;
    text-align: center;

    margin-top: px(42);
    margin-bottom: px(30);

    display: none;
  }

  @include break-medium {
    .heading {
      margin-top: px(109);
    }
  }

  @include break-small {
    .heading {
      flex-direction: column;

      margin-top: px(80);
      margin-bottom: px(24);
    }

    h3 {
      display: block;
      margin-top: 8px;
    }

    h2 {
      text-align: center;
      @include title-xs;

      span {
        @include title-l;
        display: block;

        margin-bottom: px(4);
      }
    }

    .ticker {
      display: none;
    }

    ul {
      display: flex;
    }
  }

  @include break-phone {
    .heading {
      margin-top: 22vw;
    }
  }
</style>
